import type { PaginationMetadata, PaginationQuery } from './common'

export const PRODUCT_CATEGORIES = [
  'beverage',
  'bakery',
  'food',
  'add_on',
  'merchandise',
  'other',
] as const

export type ProductCategory = (typeof PRODUCT_CATEGORIES)[number]

export const PRODUCT_CATEGORY_LABELS: Record<ProductCategory, string> = {
  beverage: 'Minuman / Beverage',
  bakery: 'Roti & Pastry / Bakery',
  food: 'Makanan / Food',
  add_on: 'Add-ons',
  merchandise: 'Merchandise',
  other: 'Lainnya / Other',
}

// Dropdown grouping only (Kopi / Non-Kopi / ...); category still drives rider bonus rules.
export const PRODUCT_MENU_GROUPS = [
  'coffee',
  'non_coffee',
  'bakery',
  'food',
  'add_on',
  'other',
] as const

export type ProductMenuGroup = (typeof PRODUCT_MENU_GROUPS)[number]

export const PRODUCT_MENU_GROUP_LABELS: Record<ProductMenuGroup, string> = {
  coffee: 'Kopi',
  non_coffee: 'Non-Kopi',
  bakery: 'Roti',
  food: 'Makanan',
  add_on: 'Extra',
  other: 'Lainnya',
}

export const PRODUCT_SOURCING_TYPES = ['produced', 'purchased'] as const

export type ProductSourcingType = (typeof PRODUCT_SOURCING_TYPES)[number]

export interface Product {
  id: string
  workspaceId: string
  sku?: string | null
  name: string
  category: ProductCategory
  menuGroup: ProductMenuGroup
  sourcingType: ProductSourcingType
  hasRecipe?: boolean
  activeRecipeVersion?: number | null
  uomId?: string | null
  photoKey?: string | null
  photoUrl?: string | null
  sellingPrice: number | null
  cogs: number
  cogsWarning: 'OK' | 'MISSING_COGS' | 'INCOMPLETE_COGS'
  /** Recipe ingredients without a cost yet (produced products only). */
  missingCostItems: string[]
  minStock?: number | null
  notes: string | null
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateProductReq {
  sku?: string | null
  name: string
  category?: ProductCategory
  menuGroup?: ProductMenuGroup
  sourcingType?: ProductSourcingType
  uomId?: string | null
  photoKey?: string | null
  sellingPrice?: number
  minStock?: number | null
  notes?: string
  // Only honored for actors with canSwitchWorkspace — everyone else always
  // creates in their own workspace regardless of what's sent here.
  workspaceId?: string
}

export interface UpdateProductReq {
  name?: string
  category?: ProductCategory
  menuGroup?: ProductMenuGroup
  sourcingType?: ProductSourcingType
  uomId?: string | null
  photoKey?: string | null
  sellingPrice?: number
  minStock?: number | null
  notes?: string
  isActive?: boolean
}

export interface GetProductReq {
  q?: string
  category?: ProductCategory
  menuGroup?: ProductMenuGroup
  isActive?: boolean
  pagination?: PaginationQuery
}

export interface ProductList {
  items: Product[]
  pagination: PaginationMetadata
}

